module.exports = __webpack_public_path__ + "img/meter-icon.4a0e29a3.png";